import * as msal from "@azure/msal-browser";
import { InteractionRequiredAuthError } from "@azure/msal-common";
import store from '../../store';

let msalInstance;

export let msalPluginInstance;

export class MsalPlugin {
    #msalOptions = {};

    install(vue, options) {
        if (!options) {
            throw new Error("MsalPluginOptions must be specified");
        }
        this.#msalOptions = options;
        this.initialize();
        msalPluginInstance = this;
        vue.prototype.$msal = msalPluginInstance;
    }

    initialize() {
        const msalConfig = this.#msalOptions.msalConfig;
        msalConfig.system = {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case msal.LogLevel.Error:
                            console.error('Error!: ' + message);
                            return;
                        case msal.LogLevel.Info:
                            console.info('Info!: ' + message);
                            return;
                        case msal.LogLevel.Verbose:
                            console.debug('Verbose!: ' + message);
                            return;
                        case msal.LogLevel.Warning:
                            console.warn('Warning!: ' + message);
                            return;
                    }
                },
                piiLoggingEnabled: false,
                logLevel: msal.LogLevel.Verbose
            }
        };
        msalInstance = new msal.PublicClientApplication(msalConfig);
    }

    async signIn() {
        const loginRequest = {
            scopes: this.#msalOptions.msalScopes//,
            //authority: 'https://gyb2cnonprod.b2clogin.com/gyb2cnonprod.onmicrosoft.com/B2C_1_USERMNGR_SUSI'
        };
        await msalInstance.handleRedirectPromise();
        // redirect promise fulfilled only after redirect
        // and getAllAccounts returns an Object also after redirect
        // so we need to get into signIn method twice: on login and after redirect
        if(!this.isAuthenticated()) {
            // no user signed in
            msalInstance.loginRedirect(loginRequest);
        } else {
            // update store auth
            store.commit("changeAuth", msalPluginInstance);
        }
    }

    async signOut() {
        await msalInstance.logout();

        store.commit("changeAuth", msalPluginInstance);
    }

    async acquireToken() {
        const redirectResponse = await msalInstance.handleRedirectPromise();
        if (redirectResponse !== null) {
            // acquire token silent success
            // call your API with token
           return redirectResponse.accessToken;
        } else {
            const accessTokenRequest = {
                account: msalInstance.getAllAccounts()[0],
                scopes: this.#msalOptions.msalScopes
            };

            try {
                let accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest);
                return accessTokenResponse.accessToken;
            } catch(error) {
                // acquire token silent failure, and send an interactive request
                //console.log(error);
                if (error instanceof InteractionRequiredAuthError) {
                    msalInstance.acquireTokenRedirect(accessTokenRequest);
                }
            }
        }
    }

    isAuthenticated() {
        const accounts = msalInstance.getAllAccounts();
        return accounts && accounts.length > 0;
    }

    isAuthorized(role) {
        let isAuthorized = false;
        const currentAccount = msalInstance.getAllAccounts()[0];
        if (currentAccount) {
            if (currentAccount.idTokenClaims.roles && currentAccount.idTokenClaims.roles.includes(role)) {
                isAuthorized = true;
            }
        }
        return isAuthorized;
    }
}